import Button from "../../../componentsNew/Button";
import Modal from "../../../componentsNew/Modal";
import Typography from "../../../componentsNew/Typography";
import iconOpti from "../../../assets/Icon_OPTI.svg";
import { useState } from "@wordpress/element";

export default function ModalWelcome() {
    const [open, setOpen] = useState(localStorage.getItem("popup-opti") == "true")

    const handleClick = (redirect) => {
        localStorage.removeItem("popup-opti")
        const domain = window.location.origin
        let link = `${domain}/wp-admin/`
        window.open("https://conteudo.opti.marketing/obrigado-por-baixar-o-plug-in", "_blank");
        switch (redirect) {
            case 'analytics':
                window.location.href = link + 'admin.php?page=analytics';
                break;
            case 'posts':
                window.location.href = link + 'edit.php';
                break;
            default:
                setOpen(false)
                break;
        }
    }

    return (
        <Modal open={open} setOpen={setOpen} className="w-modal">
            <div className="justify-center items-center w-full flex">
                <img src={iconOpti} className="w-[10.477em]" />
            </div>
            <div className="px-2 mt-9 flex flex-col">
                <Typography component="h1">Bem-vindo ao Opti</Typography>
                <Typography component="body1-modal" className="mt-4 flex flex-col">
                    O Opti é um plugin avançado para blogs em WordPress, projetado para potencializar a sua estratégia de SEO e melhorar o desempenho orgânico do seu conteúdo.
                    <Typography component="h4-bold" className="mt-4 w-full">Recursos do Opti:</Typography>
                    <ul className="list-disc list-inside mt-3">
                        <li><span className="font-bold">Monitoramento de Palavras-Chave:</span> Acompanhe diariamente o ranqueamento das palavras-chave dos seus artigos e identifique oportunidades de otimização.</li>
                        <li><span className="font-bold">Análise Avançada de SEO:</span> Otimize suas palavras-chave, corrija gramática e ortografia, e ajuste a pontuação com a ajuda de verificações automáticas.</li>
                        <li><span className="font-bold">Melhoria na Legibilidade:</span> Receba sugestões automáticas para aprimorar a legibilidade dos seus textos, garantindo uma experiência de leitura mais fluida.</li>
                        <li><span className="font-bold">Relatórios Gerenciais:</span> Obtenha insights detalhados que relacionam a posição das palavras-chave, as notas de SEO e legibilidade, e o tráfego gerado.</li>
                    </ul>
                    <Typography component="h4-bold" className="pt-3 w-full">Como Começar:</Typography>
                    <ol className="list-decimal list-inside mt-3">
                        <li><span className="font-bold">Selecione até 5 Artigos para Monitoramento:</span> No painel do Opti, escolha os artigos que deseja otimizar.</li>
                        <li><span className="font-bold">Sincronize com o Google Analytics:</span> Conecte-se ao Google Analytics para obter dados precisos de tráfego e acessos aos seus artigos.</li>
                    </ol>
                </Typography>

                <Typography component="body1-modal" className="mt-2">
                    Com o Opti, você estará no caminho certo para conquistar o topo do Google e impulsionar o sucesso do seu blog!
                </Typography>
            </div>
            <div className="flex flex-row gap-4 w-full justify-center mt-9">
                <Button className="w-[18.938em]" component="outlined" onClick={() => handleClick("posts")}><Typography component="button" >Efetuar Ações Depois</Typography></Button>
                <Button className="w-[18.938em]" component="outlined" onClick={() => handleClick("analytics")}><Typography component="button" >Conectar Google Analytics</Typography></Button>
                <Button className="w-[18.938em]" onClick={handleClick}><Typography component="button" >Adicionar Artigos</Typography></Button>
            </div>
        </Modal>
    );
}